import _ from 'lodash';
import { connect } from 'react-redux';
import { SurveyStep } from '../../models';
import { IApplicationState } from '../../store/index';
import { ActionCreators as SurveyBuilderActionCreators } from '../../store/SurveyBuilderStore';
import { SurveyPageStateSetterBase } from './SurveyPageStateSetterBase';

export const SurveyCompletePageStateSetter = connect(
	(state: IApplicationState) => ({
		...state.surveyBuilder,
		isLoading: false,
		currentStep: SurveyStep.Complete,
	}),
	{ Get: undefined, ...SurveyBuilderActionCreators },
)(SurveyPageStateSetterBase);
